import { Link } from "react-router-dom";

function Hrakleio_diagLink(value, edit, attributes) {
  if (edit) {
    <input type="text" {...attributes} value={value}></input>;
  } else {
    let output = [];
    if (value != "" && value != "Δεν Βρέθηκαν δεδομένα") {
      if (value != null && value != "(Null)") {
        var valueArr = value.split("|");

        for (var i = 0; i < valueArr.length; i++) {
          let link = valueArr[i];

          output.push(
            <Link to={link} target="new" className="d-block mt-2">
              {link}
            </Link>
          );
        }
      }
    }

    return output.length > 0 ? output : value;
  }
}

export default Hrakleio_diagLink;
